import map from "lodash/fp/map";
import constants from "../../core/constants";

class BackupplansPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Backup Plan",
      state: "backupplan",
      name: "backupPlan",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Currency", name: "currency", isSortable: true },
      { title: "Wage", name: "wage", isSortable: true },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.wage /= constants.currencyBy;

      return item;
    };
    return map(format)(data);
  }
}

export default BackupplansPageTransform;



// WEBPACK FOOTER //
// ./src/pages/backupplans/backupplans.transforms.js